/**
 * @description api请求基础路径
 */
const baseUrl = {
  dev: "/api",
  test: "http://qa-gateway.andunip.cn", // 新测试地址
  pro: "https://gateway.andunip.com"
};
/**
 * @description 腾讯上传公有桶名
 */
const uploadPublicUrl =
  process.env.type == "test" || process.env.NODE_ENV == "development"
    ? "dev-public-1251740668"
    : "pro-public-1251740668";
/**
 * @description 腾讯上传私有桶名
 */
const uploadPrivateUrl =
  process.env.type == "test" || process.env.NODE_ENV == "development"
    ? "dev-private-1251740668"
    : "pro-public-1251740668";
/**
 * @description 微信回传地址
 */
const basePath = {
  dev: "http://wechatapi.utools.club",
  test: "http://192.168.1.30:10001",
  pro: "http://cust.andunip.com"
};
/**
 * @description 接口地址 重定向链接地址
 */
export default {
  baseUrl: mapUrl(baseUrl),
  basePath: mapUrl(basePath),
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
    Accept: "application/json"
  },
  pageSizeOpts: [15, 30, 50, 100],
  pageSize: 15,
  modalPageSizeOpts: [5, 10, 15, 20],
  modalPageSize: 5,
  uploadPublicUrl: uploadPublicUrl,
  uploadPrivateUrl: uploadPrivateUrl
};

function mapUrl(url) {
  if (process.env.NODE_ENV == "development") {
    return url["dev"];
  } else if (process.env.type == "test") {
    return url["test"];
  } else {
    return url["pro"];
  }
}



// WEBPACK FOOTER //
// ./src/libs/config.js